const data = [
  {
    id: 1,
    question: "What do I need to start the project?",
    answer:
      "To begin, you'll need a clear understanding of your project goals and requirements. Once we have that, I'll guide you through the necessary steps and tools to get started.",
  },
  {
    id: 2,
    question: "How long will it take to complete the project?",
    answer:
      "The time frame depends on the project's scope and complexity. After discussing the details, I will provide an estimated completion date.",
  },
  {
    id: 5,
    question: "Are hosting and domain registration included in the price?",
    answer:
      "No, hosting and domain registration are handled separately. You can either manage them yourself or I can assist you in setting them up.",
  },
  {
    id: 4,
    question: "How much does the project cost?",
    answer:
      "Pricing varies depending on the project's complexity. I ensure that the pricing is affordable and fair based on your requirements.",
  },
  {
    id: 3,
    question: "What’s your payment plan?",
    answer:
      "Payment is divided into 3 parts: 30% upfront to start the project, 40% upon project completion, and the remaining 30% upon delivery.",
  },
  {
    id: 6,
    question: "What if the project doesn't meet my expectations?",
    answer:
      "You’ll be involved in every stage of the project, so you'll have full visibility. I'll make sure the project aligns with your goals and meets your expectations.",
  },
];

export default data;
